import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import HomePage from 'screens/public/home/index.jsx';
import LoginPage from 'screens/public/login/index.jsx';
import ManagementTemplate from 'templates/management-template/index.jsx';
import StoreTemplate from 'templates/store-template/index.jsx';
import CarouselItemsManagementPage from 'screens/private/carousel-items/index.jsx';
import CategoriesManagementPage from 'screens/private/categories/index.jsx';
import ProductsManagementPage from 'screens/private/products/index.jsx';
import ProductsPage from 'screens/public/products/index.jsx';
import ProductDetail from 'screens/public/product-detail';
import Settings from 'screens/private/settings';
import TradeFormPage from 'screens/public/trade-form/index.jsx';
import ManagementHomePage from 'screens/private/home/index.jsx';

const Routes = () => {
  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: '/management',
      element: <ManagementTemplate />,
      children: [
        {
          path: '/management',
          element: <ManagementHomePage />,
        },
        {
          path: '/management/carousel-items',
          element: <CarouselItemsManagementPage />,
        },
        {
          path: '/management/categories',
          element: <CategoriesManagementPage />,
        },
        {
          path: '/management/products',
          element: <ProductsManagementPage />,
        },
        {
          path: '/management/settings',
          element: <Settings />,
        },
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const publicRoutes = [
    {
      path: '/',
      element: <StoreTemplate />,
      children: [
        {
          path: '/',
          element: <HomePage />,
        },
        {
          path: '/products',
          element: <ProductsPage />,
        },
        {
          path: '/product/:id',
          element: <ProductDetail />,
        },
        {
          path: '/trade-form',
          element: <TradeFormPage />,
        },
      ],
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
  ];

  const router = createBrowserRouter([...publicRoutes, ...routesForAuthenticatedOnly]);

  return <RouterProvider router={router} />;
};

export default Routes;
